import React, { useEffect, useState } from "react";

import { useAPIs } from "../../apis/APIsConfig";
import { downloadPDFByPost } from "../../services/utils";
import Accordion from "../common/Accordion";
import { useGlobalStore } from "../../utils/global"; 
import { getAfiliado } from "../../services/profile"; // BPMS-related imports
import { getBPMSExternalLogin } from "../../services/benefits";

export function Step2({ ...props }) {
  useAPIs();
  const { bpmsActive } = useGlobalStore();
  const hasFormularios = props.requirements.some((requirement) => requirement.formulario);

  useEffect(() => {
    console.info(props);
  }, []);

  const handleContinue = () => {
    
    if (bpmsActive) {
      // Execute the BPMS logic directly when bpmsActive is true
      getAfiliado().then((res) => {
        if (res && res.data.successed) {
          const afiliado = { ...res.data.value };

          if (afiliado.numeroIdentificacion && afiliado.nombresCompletos) {
            getBPMSExternalLogin(
              afiliado.numeroIdentificacion,
              afiliado.nombresCompletos,
              afiliado.email ?? ""
            ).then((resp) => {
              if (resp === undefined) {
                getBPMSExternalLogin(
                  afiliado.numeroIdentificacion,
                  afiliado.nombresCompletos,
                  afiliado.email ?? ""
                ).then((resp) => {
                  if (resp && resp?.data?.successed) {
                    window.open(resp.data.value, '_self');
                  }
                });
              } else if (resp && resp?.data?.successed) {
                window.open(resp.data.value, '_self');
              }
            });
          }
        }
      }).catch((error) => {
        console.error("Error with BPMS logic:", error);
      });
    } else {
      // Continue to the next step if bpmsActive is false
      props.next();
    }
  };

  return (
    <>
      <div className="accordion-container">
        <Accordion title="Requisitos">
          <div className="description">
            <div className="text">
              <p>Condiciones:</p>
              <ul className="list-requirements">
                {props.conditions.map((condition, index) => (
                  <li key={index}>{condition}</li>
                ))}
              </ul>
            </div>
            <div className="text">
              <p>Documentos Requeridos:</p>
              <ul className="list-requirements">
                {props.requirements.map((requirement, index) => (
                  <li key={index}>{requirement.descripcion}</li>
                ))}
              </ul>
            </div>
          </div>
        </Accordion>
        {!bpmsActive && hasFormularios && (
        <Accordion title="Formularios">
          <div className="description">
            <p className="text-body-1 text-gray-70 font-body font-normal mb-6">
              Favor descarga, completa, firma y adjunta los siguientes
              formularios
            </p>
            <div className="block space-y-4">
              {props.requirements
                .filter((r) => r.formulario)
                .map((requirement, index) => (
                  <a
                    href={
                      process.env.REACT_APP_STATICFILES_URL +
                      requirement.formulario
                    }
                    target="_blank"
                    className="btn-download"
                    key={index}
                  >
                    <div className="flex items-center pr-2">
                      <div className="icon-container">
                        <i className="icon icon-saved"></i>
                      </div>
                      <h5 className="text-body-1 text-gray-80 font-body font-semibold pl-4">
                        {requirement.descripcion}
                      </h5>
                    </div>
                    <i className="icon icon-download text-[26px] text-gray-50"></i>
                  </a>
                ))}
            </div>
          </div>
        </Accordion>
        )}
      </div>
      <div className="grid grid-cols-2 gap-4 md:gap-6 pt-[128px] md:pt-8">
        <button
          onClick={() => props.prev()}
          className="btn btn-secondary btn-large w-full"
        >
          Volver
        </button>
        {props.soloInformacion ? (
          <button
            onClick={() => props.cancel()}
            className="btn btn-primary btn-large w-full"
          >
            Cerrar
          </button>
        ) : (
          <button
            onClick={handleContinue}
            className="btn btn-primary btn-large w-full"
          >
            Iniciar Solicitud
          </button>
        )}
      </div>
    </>
  );
}
